import Vue from 'vue';

Vue.filter('FormatDocument', (documentId, documentType) => {
    if (documentId) {
        documentId = (typeof documentId != 'string' ? documentId.toString() : documentId);
        if (documentType == 'J') {
            // AUCR-811: CNPJ alfanumérico — normaliza e mascara por posição (DV numérico)
            documentId = documentId.trim().toUpperCase().replace(/[.\-/\s]/g, '');
            if (/^\d+$/.test(documentId) && documentId.length < 14) documentId = documentId.padStart(14, '0');
            documentId = documentId.replace(/^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
            documentId = documentId.padStart(11, '0');
            documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
    }
    return documentId;
});